<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconChat_24"
    viewBox="0 0 24 24"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        d="M17.5 2h-12A4.5 4.5 0 0 0 1 6.5v15.012c0 .885 1.131 1.254 1.653.54l2.038-2.788A3.078 3.078 0 0 1 7.179 18H17.5a4.5 4.5 0 0 0 4.5-4.5v-7A4.5 4.5 0 0 0 17.5 2ZM17 12.75H6v-1.5h11v1.5Zm0-4H6v-1.5h11v1.5Z"
    />
</svg>
